import { DashboardFilter } from "../../types/dashboard";

interface ISelectedFiltersProps {
  requestFilters: DashboardFilter;
}

const SelectedFilters = ({ requestFilters }: ISelectedFiltersProps) => {
  const checkingAvailableFilters = () => {
    if (
      !requestFilters?.categoryIds?.length &&
      !requestFilters?.clientIds?.length &&
      !requestFilters?.contracts?.length &&
      !requestFilters?.vehicleIds?.length
    )
      return false;

    return true;
  };

  const categories = requestFilters?.categoryIds?.length;
  const clients = requestFilters?.clientIds?.length;
  const contracts = requestFilters?.contracts?.length;
  const vehicles = requestFilters?.vehicleIds?.length;

  return (
    <div className="display-flex align-items-center gap-10">
      {checkingAvailableFilters() ? (
        <>
          <p className="margin-0 text-size-18 text-bold">Visão detalhada da operação selecionada:</p>
          <div className="display-flex align-items-center gap-20">
            {categories ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-tag text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{categories}</p>
                <p className="margin-0 text-size-16">{categories === 1 ? "Categoria" : "Categorias"}</p>
              </div>
            ) : null}

            {clients ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-transfer text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{clients}</p>
                <p className="margin-0 text-size-16">{clients === 1 ? "Cliente" : "Clientes"}</p>
              </div>
            ) : null}

            {contracts ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-file-signature text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{contracts}</p>
                <p className="margin-0 text-size-16">{contracts === 1 ? "Contrato" : "Contratos"}</p>
              </div>
            ) : null}

            {vehicles ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-van-baseline text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{vehicles}</p>
                <p className="margin-0 text-size-16">{vehicles === 1 ? "Veículo" : "Veículos"}</p>
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default SelectedFilters;
